import React, { useState, useEffect } from 'react';
import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label, FormGroup } from 'reactstrap';
import { ActividadesPlanificadas, DetalleRegimenLaboralHEDTO, DetalleServidoresPlanificacionHE, ServidorSeleccionado, unidadesEspeciales } from './TypesPlanificacionHE';

import Swal from 'sweetalert2';

import WarningSVG from './../../../../assets/icons/HorasExtras/Informativa N.svg';
import WErrorSVG from './../../../../assets/icons/HorasExtras/Informativa R.svg';
import { DetalleServidoresProyHEDTO, isParametroRegimenModificacion, isParametroRegimenPlanificacion, isParametroRegimenProyeccion } from '../ProyeccionHE/TypesProyeccionDirectivo';
import { calcularValorHorabyRMU, calcularValorHoraExtraordinariabyRMU, calcularValorHoraSuplementariasbyRMU, calcularValorTotalExtraordinarias, calcularValorTotalHora, calcularValorTotalSuplementarias } from './FunctionsPlanificacionHE';
import { DetalleServidoresModificacionHE } from '../Modificación Presupuesto Unidad/TypesModificacion';

type PropsTableServidoresPlanHE = {
    servidoresPlan: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[],
    selectedServidoresAnt: { [key: number]: ServidorSeleccionado },
    initialSelectedServidores: { [key: number]: ServidorSeleccionado },
    regimenSeleccionado: number,
    horasExtraordinarias: number | undefined,
    horasSuplementarias: number | undefined,
    maxHorasExtraordinarias: number | undefined,
    maxHorasSuplementarias: number | undefined,
    maxHorasExtraySuple: number | undefined,
    onSelectionChange: (selected: { [key: number]: any }) => void,
    isCrear: boolean,
    rowsPerPage?: number,
    regimenLaboralesPlan: DetalleRegimenLaboralHEDTO[];
    onBudgetExceed: (isExceed: boolean) => void
    idEstructura: number,
    idActividad: number,
    observacion?:string,
    factorMesesPlan?: number,
    tipo: "PR" | "PL" | "MD"
}

export default function TableModalActServidoresPlanHE(props: PropsTableServidoresPlanHE) {

    const defaultSelectedServidor: ServidorSeleccionado = {
        idpersona: 0,
        identificacion: '',
        nombrecompleto: '',
        cargo: '',
        siglasregimen: '',
        rmu: 0,
        idregimen: 0,
        horasExtraordinarias: undefined,
        observacion: '',
        horasSuplementarias: undefined,
    };

    const { initialSelectedServidores, selectedServidoresAnt, servidoresPlan, regimenSeleccionado, horasExtraordinarias, horasSuplementarias, maxHorasExtraordinarias, maxHorasSuplementarias, maxHorasExtraySuple, isCrear, regimenLaboralesPlan } = props;



    const [selectedServidores, setSelectedServidores] = useState<{ [key: number]: ServidorSeleccionado }>(selectedServidoresAnt);
    

    const maxNroActividades = 5;



    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage ?? 10);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);

    const [totalDevengado, setTotalDevengado] = useState(0);
    const [errorValorDevengado, setErrorValorDevengado] = useState(false);

    var tipoInformacion = "";

    if (isParametroRegimenPlanificacion(servidoresPlan[0])) {
        tipoInformacion = "PL"
    }
    else if (isParametroRegimenProyeccion(servidoresPlan[0])) {
        tipoInformacion = "PR"
    }

    

    useEffect(() => {
        // if (isCrear && (horasExtraordinarias !== undefined || horasSuplementarias !== undefined)) {
        //     let nuevoTotalDevengado = 0;
        //     setSelectedServidores(prevSelected => {
        //         const updatedSelected = { ...prevSelected };
        //         for (const key in updatedSelected) {
        //             if (updatedSelected.hasOwnProperty(key)) {
        //                 updatedSelected[key] = {
        //                     ...updatedSelected[key],
        //                     horasExtraordinarias: horasExtraordinarias !== undefined ? horasExtraordinarias : updatedSelected[key].horasExtraordinarias,
        //                     horasSuplementarias: horasSuplementarias !== undefined ? horasSuplementarias : updatedSelected[key].horasSuplementarias
        //                 };

        //                 const valorHora = calcularValorHorabyRMU(updatedSelected[key].rmu);
        //                 const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(updatedSelected[key].idregimen, valorHora);
        //                 const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(updatedSelected[key].idregimen, valorHora);

        //                 const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, updatedSelected[key].horasSuplementarias || 0);
        //                 const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, updatedSelected[key].horasExtraordinarias || 0);

        //                 nuevoTotalDevengado += calcularValorTotalHora(valorTotalSuplementarias, valorTotalExtraordinarias);
        //             }
        //         }
        //         return updatedSelected;
        //     });

        //     setTotalDevengado(nuevoTotalDevengado);

        //     let regimenValidacion = regimenLaboralesPlan.filter(r => r.idRegimenLaboral === 999);
        //     if (regimenValidacion.length > 0 && regimenValidacion[0].presupuestoDevengar < nuevoTotalDevengado) {
        //         showAlertWarning('Se está excediendo del presupuesto a devengar', WErrorSVG, true);
        //         props.onBudgetExceed(true);
        //         return;
        //     }
        //     props.onBudgetExceed(false);
        // }
    }, [horasExtraordinarias, horasSuplementarias, isCrear]);


    useEffect(() => {
        if (Object.keys(selectedServidoresAnt).length > 0) {

            let nuevoTotalDevengado = 0;

            Object.values(selectedServidoresAnt).forEach((servidor) => {
                const valorHora = calcularValorHorabyRMU(servidor.rmu);
                const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(servidor.idregimen, valorHora);
                const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(servidor.idregimen, valorHora);

                const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, servidor.horasSuplementarias);
                const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, servidor.horasExtraordinarias);
                const valorTotal = calcularValorTotalHora(valorTotalSuplementarias, valorTotalExtraordinarias);

                nuevoTotalDevengado += valorTotal;
            });

            setTotalDevengado(nuevoTotalDevengado);


        } else {
            console.log("Está vacío");
        }
    }, [selectedServidoresAnt])


    async function showAlertWarning(message, imageSrc, isError) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isError ? 'Error' : 'Warning',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#243165'
        });
    }

    let filteredServidores: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[] = []

    if (servidoresPlan && servidoresPlan.length > 0) {

        if (isParametroRegimenProyeccion(servidoresPlan[0])) {
            filteredServidores = (servidoresPlan as DetalleServidoresProyHEDTO[]).filter((serv, index) => {
                return (
                    (serv.nombrescompletos.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.cargo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.identificacion.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.siglasregimenlaboral.toLowerCase().includes(searchTerm.toLowerCase()))
                    && serv.idregimenlaboral == regimenSeleccionado
                )
            });
        }
        else if (isParametroRegimenPlanificacion(servidoresPlan[0])) {
            filteredServidores = (servidoresPlan as DetalleServidoresPlanificacionHE[]).filter((serv, index) => {
                return (
                    (serv.nombrescompletos.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.cargo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.identificacion.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.siglasregimenlaboral.toLowerCase().includes(searchTerm.toLowerCase()))
                    && serv.idregimenlaboral == regimenSeleccionado
                )
            });
        }
        else if (isParametroRegimenModificacion(servidoresPlan[0])) {
            filteredServidores = (servidoresPlan as DetalleServidoresModificacionHE[]).filter((serv, index) => {
                return (
                    (serv.nombrescompletos.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.cargo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.identificacion.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        serv.siglasregimenlaboral.toLowerCase().includes(searchTerm.toLowerCase()))
                    && serv.idregimenlaboral == regimenSeleccionado
                )
            });
        }

    }


    function ObtenerTbody(currentRows: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[]) {

        if (isParametroRegimenProyeccion(currentRows[0])) {
            const contenido = (currentRows as DetalleServidoresProyHEDTO[]).map((serv, idServ) => {
                const globalIndex = indexOfFirstRow + idServ + 1
                return (
                    <React.Fragment key={idServ}>
                        <tr className='rows_tabla_planificacion_he' key={serv.idpersona}>
                            <td >
                                <div className='text-right pr-1'>
                                    {globalIndex}
                                </div>
                            </td>
                            <td>{serv.identificacion}</td>
                            <td colSpan={2}>{serv.nombrescompletos}</td>
                            <td colSpan={2}>{serv.cargo}</td>
                            <td className="centrado">{serv.siglasregimenlaboral}</td>
                            <td className="centrado">
                                {selectedServidores[serv.idpersona]?.horasSuplementarias === 0 || selectedServidores[serv.idpersona]?.horasSuplementarias === undefined ? '' : selectedServidores[serv.idpersona]?.horasSuplementarias}

                            </td>
                            <td className="centrado"> {selectedServidores[serv.idpersona]?.horasExtraordinarias === 0 || selectedServidores[serv.idpersona]?.horasExtraordinarias === undefined ? '' : selectedServidores[serv.idpersona]?.horasExtraordinarias}

                            </td>

                            <td className="centrado">
                                <input
                                    type="checkbox"
                                    checked={!!selectedServidores[serv.idpersona]}
                                    onChange={() => handleSelectOne(serv)}
                                    title='Seleccionar servidor'
                                />
                            </td>
                        </tr>
                    </React.Fragment>
                )
            })
            return contenido
        }
        else if (isParametroRegimenModificacion(currentRows[0])) {
            const contenido = (currentRows as DetalleServidoresModificacionHE[]).map((serv, idServ) => {
                const globalIndex = indexOfFirstRow + idServ + 1
                return (
                    <React.Fragment key={idServ}>
                        <tr className='rows_tabla_planificacion_he' key={serv.idpersona}>
                            <td >
                                <div className='text-right pr-1'>
                                    {globalIndex}
                                </div>
                            </td>
                            <td>{serv.identificacion}</td>
                            <td colSpan={2}>{serv.nombrescompletos}</td>
                            <td colSpan={2}>{serv.cargo}</td>
                            <td className="centrado">{serv.siglasregimenlaboral}</td>
                            <td className="centrado">
                                {selectedServidores[serv.idpersona]?.horasSuplementarias === 0 || selectedServidores[serv.idpersona]?.horasSuplementarias === undefined ? '' : selectedServidores[serv.idpersona]?.horasSuplementarias}
                            </td>
                            <td className="centrado"> {selectedServidores[serv.idpersona]?.horasExtraordinarias === 0 || selectedServidores[serv.idpersona]?.horasExtraordinarias === undefined ? '' : selectedServidores[serv.idpersona]?.horasExtraordinarias}
                            </td>
                            <td className="centrado">
                                <input
                                    type="checkbox"
                                    checked={!!selectedServidores[serv.idpersona]}
                                    onChange={() => handleSelectOne(serv)}
                                    title='Seleccionar servidor'
                                />
                            </td>
                        </tr>
                    </React.Fragment>
                )
            })
            return contenido
        }
        else {
            const contenido = (currentRows as DetalleServidoresProyHEDTO[]).map((serv, idServ) => {
                const globalIndex = indexOfFirstRow + idServ + 1
                const actividad = serv.actividadesplanificadas.find((v) => v.value.idActividad === props.idActividad)
                var observacion = "";
                if (actividad !== undefined || selectedServidores[serv.idpersona]?.observacion !== undefined) {
                    observacion =selectedServidores[serv.idpersona]?.observacion ??"" //selectedServidores[serv.idpersona]?.observacion !== undefined ? selectedServidores[serv.idpersona]?.observacion??"" : actividad.value.observacion;
                }



                return (
                    <React.Fragment key={idServ}>

                        <tr className='rows_tabla_planificacion_he' key={serv.idpersona}>
                            <td >
                                <div className='text-right pr-1'>
                                    {globalIndex}
                                </div>
                            </td>
                            <td className="tdIdentificacion">{serv.identificacion}</td>
                            <td className="tdNombres" colSpan={2}>{serv.nombrescompletos}</td>
                            <td className="tdCargo" colSpan={2}>{serv.cargo}</td>
                            <td className="centrado">{serv.siglasregimenlaboral}</td>
                            <td className="centrado">
                                {selectedServidores[serv.idpersona]?.horasSuplementarias === 0 || selectedServidores[serv.idpersona]?.horasSuplementarias === undefined ? '' : selectedServidores[serv.idpersona]?.horasSuplementarias}

                            </td>
                            <td className="centrado"> {selectedServidores[serv.idpersona]?.horasExtraordinarias === 0 || selectedServidores[serv.idpersona]?.horasExtraordinarias === undefined ? '' : selectedServidores[serv.idpersona]?.horasExtraordinarias}

                            </td>
                            <td>
                                <FormGroup>
                                    <Input
                                        id={"actividad" + idServ}
                                        name={"actividadName" + idServ}
                                        maxLength="200"
                                        className="inputActividadHE"
                                        value={observacion}
                                        onChange = {(e) => handleChangeSelection(serv,e.target.value)}
                                        type="textarea"
                                        placeholder={!!selectedServidores[serv.idpersona] ? "Debe ingresar una observación (máx. 200 caracteres)" : ""}
                                        autoComplete='off'
                                    />
                                </FormGroup>



                            </td>
                            <td className="centrado">
                                <input
                                    type="checkbox"
                                    checked={!!selectedServidores[serv.idpersona]}
                                    onChange={() => handleSelectOne(serv)}
                                    title='Seleccionar servidor'
                                />
                            </td>
                        </tr>
                    </React.Fragment>
                )
            }

            )
            return contenido
        }



    }


    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    let currentRows = filteredServidores.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredServidores.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    /*const applySorting = (data) => {
        if (!sortColumn) return data;
        if(sortColumn!==null){
            const sortedData = [...data].sort((a, b) => {
                const valA = a[sortColumn];
                const valB = b[sortColumn];
                return (valA < valB ? -1 : 1) * (sortDirection === 'asc' ? 1 : -1);
            });
            return sortedData;
        }
        return data;
    };

    const sortedServidores = applySorting(filteredServidores);
    currentRows = sortedServidores.slice(indexOfFirstRow, indexOfLastRow);*/

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página
    };


    function FiltrarServidoresExceden(currentRows: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[]) {
        var idServidores: number[] = [];
        currentRows.forEach((servidor) => {
            let maxHorasExtraor = (servidor.horasextraordinarias ? servidor.horasextraordinarias : 0) + (horasExtraordinarias ? horasExtraordinarias : 0);
            let maxHorasSuple = (servidor.horassuplementarias ? servidor.horassuplementarias : 0) + (horasSuplementarias ? horasSuplementarias : 0);
            let sumaHorasExtraSuple = maxHorasExtraor + maxHorasSuple;
            let regimenValidacion = regimenLaboralesPlan.filter(r => r.idRegimenLaboral === 999);

            if (props.factorMesesPlan) {
                if (maxHorasExtraordinarias && maxHorasExtraor > (props.factorMesesPlan * maxHorasExtraordinarias)) {
                    idServidores.push(servidor.idpersona)
                    return;
                }

                if (maxHorasSuplementarias && maxHorasSuple > (props.factorMesesPlan * maxHorasSuplementarias)) {
                    idServidores.push(servidor.idpersona)
                    return;
                }

                if (maxHorasExtraySuple && sumaHorasExtraSuple > (props.factorMesesPlan * maxHorasExtraySuple)) {
                    idServidores.push(servidor.idpersona)
                    return;
                }
            }
            else {
                if (maxHorasExtraordinarias && maxHorasExtraor > maxHorasExtraordinarias) {
                    idServidores.push(servidor.idpersona)
                    return;
                }

                if (maxHorasSuplementarias && maxHorasSuple > maxHorasSuplementarias) {
                    idServidores.push(servidor.idpersona)
                    return;
                }

                if (maxHorasExtraySuple && sumaHorasExtraSuple > maxHorasExtraySuple) {
                    idServidores.push(servidor.idpersona)
                    return;
                }
            }

        });
        return idServidores;
    }

    /*const handleSelectAll = (e) => {
        const newSelection = {};
        let nuevoTotalDevengado = 0;
        if (horasExtraordinarias === undefined && horasSuplementarias === undefined) {
            showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
            return;
        } else if (horasExtraordinarias === 0 && horasSuplementarias === 0) {
            showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
            return;
        }
        let selecthorasExtraordinarias: number | undefined = 0;
        let selecthorasSuplementarias: number | undefined = 0;

        selecthorasExtraordinarias = horasExtraordinarias
        selecthorasSuplementarias = horasSuplementarias

        if (e.target.checked) {
            for (const servidor of servidoresPlan) {
                let maxHorasExtraor = (servidor.horasextraordinarias ? servidor.horasextraordinarias : 0) + (horasExtraordinarias ? horasExtraordinarias : 0);
                let maxHorasSuple = (servidor.horassuplementarias ? servidor.horassuplementarias : 0) + (horasSuplementarias ? horasSuplementarias : 0);
                let sumaHorasExtraSuple = maxHorasExtraor + maxHorasSuple;
                let regimenValidacion = regimenLaboralesPlan.filter(r => r.idRegimenLaboral === 999);

                if (regimenValidacion.length > 0 && regimenValidacion[0].presupuestoDevengar === 0) {
                    showAlertWarning('El presupuesto por devengar de su unidad está en cero.', WErrorSVG, true);
                    return;
                }

                if (maxHorasExtraordinarias && maxHorasExtraor > maxHorasExtraordinarias) {
                    showAlertWarning('Alguno de los servidores ya excede el valor límite de horas extraordinarias', WErrorSVG, true);
                    return;
                }

                if (maxHorasSuplementarias && maxHorasSuple > maxHorasSuplementarias) {
                    showAlertWarning('Alguno de los servidores ya excede el valor límite de horas suplementarias', WErrorSVG, true);
                    return;
                }

                if (maxHorasExtraySuple && sumaHorasExtraSuple > maxHorasExtraySuple) {
                    showAlertWarning('Alguno de los servidores ya excede el valor límite de horas suplementarias y extraordinarias', WErrorSVG, true);
                    return;
                }

                if (servidor.numactividades && servidor.numactividades === maxNroActividades) {
                    showAlertWarning('Alguno de los servidores ya tiene el número máximo de actividades', WErrorSVG, true);
                    return;
                }


                const valorHora = calcularValorHorabyRMU(parseInt(servidor.rmu));
                const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(servidor.idregimenlaboral, valorHora);
                const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(servidor.idregimenlaboral, valorHora);

                const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, selecthorasSuplementarias);
                const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, selecthorasExtraordinarias);
                const valorTotal = calcularValorTotalHora(valorTotalSuplementarias, valorTotalExtraordinarias);

                // Sumar el valor total del servidor al total global
                nuevoTotalDevengado += valorTotal;

                newSelection[servidor.idpersona] = {
                    idpersona: servidor.idpersona,
                    identificacion: servidor.identificacion,
                    nombrecompleto: servidor.nombrescompletos,
                    cargo: servidor.cargo,
                    siglasregimen: servidor.siglasregimenlaboral,
                    rmu: parseFloat(servidor.rmu),
                    idregimen: servidor.idregimenlaboral,
                    horasExtraordinarias: selecthorasExtraordinarias,
                    horasSuplementarias: selecthorasSuplementarias
                };
            }

            const regimenValidacion = regimenLaboralesPlan.filter(r => r.idRegimenLaboral === 999);
            if (regimenValidacion.length > 0 && regimenValidacion[0].presupuestoDevengar < nuevoTotalDevengado) {
                showAlertWarning('Se está excediendo del presupuesto a devengar', WErrorSVG, true);
                return;
            }
        } else {
            // If the checkbox is unchecked, clear the selection
            setSelectedServidores({});
            props.onSelectionChange({});
            return;
        }

        setSelectedServidores(newSelection);
        props.onSelectionChange(newSelection);
    };*/

    const handleSelectAll = (e) => {
        let newSelection = { ...selectedServidores };

        let nuevoTotalDevengado = 0;

        // Si las horas no están definidas, mostramos la alerta
        if (horasExtraordinarias === undefined && horasSuplementarias === undefined) {
            showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
            return;
        } else if (horasExtraordinarias === 0 && horasSuplementarias === 0) {
            showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
            return;
        }



        //Primero se verifica si de los servidores seleccionados existe personal que se excede.
        const idServidoresExceden = FiltrarServidoresExceden(currentRows)
        var copiaFiltradosCurrentRows = [...currentRows]
        // const filteredSelection = Object.fromEntries(
        //     Object.entries(newSelection).filter(([key]) => !idServidoresExceden.includes(Number(key)))
        // );
        copiaFiltradosCurrentRows = copiaFiltradosCurrentRows.filter((v) => !idServidoresExceden.includes(v.idpersona));

        //Se considera que todo el personal ha sido seleccionado si es que se ha seleccionado a todo el personal excepto los que ya se exceden del presupuesto.
        //Esto es debido a que este valor decide si se deselecciona todo o no
        const allFilteredSelected = copiaFiltradosCurrentRows.every((serv) => selectedServidores[serv.idpersona]);

        //copiaFiltradosSelected.every((serv) => selectedServidores[serv.idpersona]);
        //true; //currentRows.every((serv) => selectedServidores[serv.idpersona]);

        if (allFilteredSelected) {

            // Si todos están seleccionados, los deseleccionamos
            currentRows.forEach((servidor) => {
                const valorHora = calcularValorHorabyRMU(parseInt(servidor.rmu));
                const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(servidor.idregimenlaboral, valorHora);
                const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(servidor.idregimenlaboral, valorHora);

                const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, horasSuplementarias);
                const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, horasExtraordinarias);
                const valorTotal = calcularValorTotalHora(valorTotalSuplementarias, valorTotalExtraordinarias);

                // Restamos el valor devengado
                nuevoTotalDevengado -= valorTotal;

                delete newSelection[servidor.idpersona]; // Remover del objeto de seleccionados
            });
        } else {

            // Si no están todos seleccionados, los seleccionamos
            currentRows.forEach((servidor) => {

                var nroHorasExtrDeEstaActividad: number | undefined = 0;
                var nroHorasSuplDeEstaActividad: number | undefined = 0;

                if (servidor.actividadesplanificadas.length > 0) {
                    const informacionActividades: Array<{ key: number, value: ActividadesPlanificadas }> = servidor.actividadesplanificadas;
                    const estructuraActual: number = props.idEstructura
                    for (let index = 0; index < informacionActividades.length; index++) {
                        const actividad = informacionActividades[index];
                        if (actividad.value.idActividad === props.idActividad && actividad.value.idEstructura === estructuraActual) {
                            nroHorasExtrDeEstaActividad += (actividad.value.horasExtraordinarias ?? 0)
                            nroHorasSuplDeEstaActividad += (actividad.value.horasSuplementarias ?? 0)
                        }
                    }
                }

                let maxHorasExtraor = (servidor.horasextraordinarias ? servidor.horasextraordinarias : 0) + (horasExtraordinarias ? horasExtraordinarias : 0);
                let maxHorasSuple = (servidor.horassuplementarias ? servidor.horassuplementarias : 0) + (horasSuplementarias ? horasSuplementarias : 0);
                let sumaHorasExtraSuple = maxHorasExtraor + maxHorasSuple;
                let regimenValidacion = regimenLaboralesPlan.filter(r => r.idRegimenLaboral === 999);

                if (!props.isCrear) {

                    maxHorasExtraor = maxHorasExtraor - nroHorasExtrDeEstaActividad;
                    maxHorasSuple = maxHorasSuple - nroHorasSuplDeEstaActividad;
                    sumaHorasExtraSuple = maxHorasExtraor + maxHorasSuple
                }

                if (regimenValidacion.length > 0 && regimenValidacion[0].presupuestoDevengar === 0) {
                    showAlertWarning('El presupuesto por devengar de su unidad está en cero.', WErrorSVG, true);
                    return;
                }

                if (props.factorMesesPlan) {

                    if (maxHorasExtraordinarias && maxHorasExtraor > (props.factorMesesPlan * maxHorasExtraordinarias)) {
                        showAlertWarning('Alguno de los servidores ya excede el valor límite de horas extraordinarias', WErrorSVG, true);
                        return;
                    }

                    if (maxHorasSuplementarias && maxHorasSuple > (props.factorMesesPlan * maxHorasSuplementarias)) {
                        showAlertWarning('Alguno de los servidores ya excede el valor límite de horas suplementarias', WErrorSVG, true);
                        return;
                    }

                    if (maxHorasExtraySuple && sumaHorasExtraSuple > (props.factorMesesPlan * maxHorasExtraySuple)) {
                        showAlertWarning('Alguno de los servidores ya excede el valor límite de horas suplementarias y extraordinarias', WErrorSVG, true);
                        return;
                    }
                }
                else {
                    if (maxHorasExtraordinarias && maxHorasExtraor > maxHorasExtraordinarias) {
                        showAlertWarning('Alguno de los servidores ya excede el valor límite de horas extraordinarias', WErrorSVG, true);
                        return;
                    }

                    if (maxHorasSuplementarias && maxHorasSuple > maxHorasSuplementarias) {
                        showAlertWarning('Alguno de los servidores ya excede el valor límite de horas suplementarias', WErrorSVG, true);
                        return;
                    }

                    if (maxHorasExtraySuple && sumaHorasExtraSuple > maxHorasExtraySuple) {
                        showAlertWarning('Alguno de los servidores ya excede el valor límite de horas suplementarias y extraordinarias', WErrorSVG, true);
                        return;
                    }
                }



                const valorHora = calcularValorHorabyRMU(parseInt(servidor.rmu));
                const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(servidor.idregimenlaboral, valorHora);
                const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(servidor.idregimenlaboral, valorHora);

                const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, horasSuplementarias);
                const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, horasExtraordinarias);
                const valorTotal = calcularValorTotalHora(valorTotalSuplementarias, valorTotalExtraordinarias);

                nuevoTotalDevengado += valorTotal;

                newSelection[servidor.idpersona] = {
                    idpersona: servidor.idpersona,
                    identificacion: servidor.identificacion,
                    nombrecompleto: servidor.nombrescompletos,
                    cargo: servidor.cargo,
                    siglasregimen: servidor.siglasregimenlaboral,
                    rmu: parseFloat(servidor.rmu),
                    idregimen: servidor.idregimenlaboral,
                    horasExtraordinarias: horasExtraordinarias,
                    horasSuplementarias: horasSuplementarias
                };
            });
        }

        setSelectedServidores(newSelection);
        props.onSelectionChange(newSelection);
        setTotalDevengado(nuevoTotalDevengado); // Actualizamos el total devengado
    };


    //const allSelected = Object.keys(selectedServidores).length === servidoresPlan.length && servidoresPlan.length > 0;
    const allSelected = (currentRows as any[]).every(
        serv => selectedServidores[serv.idpersona]
    );

    console.log(totalDevengado)
    const handleSelectOne = (serv) => {



        let isDeselecting = !!selectedServidores[serv.idpersona]; // Si ya está seleccionado, es un des-seleccionado

        let selecthorasExtraordinarias: number | undefined = 0;
        let selecthorasSuplementarias: number | undefined = 0;

        selecthorasExtraordinarias = horasExtraordinarias;
        selecthorasSuplementarias = horasSuplementarias;




        let regimenValidacion = regimenLaboralesPlan.filter(r => r.idRegimenLaboral === 999);

        if (regimenValidacion.length > 0 && regimenValidacion[0].presupuestoDevengar === 0) {
            showAlertWarning('El presupuesto por devengar de su unidad está en cero.', WErrorSVG, true);
            return;
        }

        if (isDeselecting) {
            const newSelection = { ...selectedServidores };
            


            const valorHora = calcularValorHorabyRMU(serv.rmu);
            const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(serv.idregimenlaboral, valorHora);
            const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(serv.idregimenlaboral, valorHora);

            //const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, selecthorasSuplementarias);
            //const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, selecthorasExtraordinarias);

            const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, selectedServidores[serv.idpersona].horasSuplementarias);
            const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, selectedServidores[serv.idpersona].horasExtraordinarias);
            const valorTotal = calcularValorTotalHora(valorTotalSuplementarias, valorTotalExtraordinarias);

            setTotalDevengado(prevTotal => prevTotal - valorTotal);

            delete newSelection[serv.idpersona]; // Removemos el servidor de la selección
            setSelectedServidores(newSelection);
            props.onSelectionChange(newSelection);
            return; // Terminamos aquí, sin validaciones
        }

        // Realizamos validaciones solo cuando es selección (no des-selección)
        if (horasExtraordinarias === undefined && horasSuplementarias === undefined) {
            showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
            return;
        } else if (horasExtraordinarias === 0 && horasSuplementarias === 0) {
            showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
            return;
        }


        // if(tipoInformacion === "PL" && !props.observacion){
        //     showAlertWarning('Debe indicar la observación de la actividad', WarningSVG, true);
        //     return;
        // }

        if (selecthorasExtraordinarias !== undefined && selecthorasExtraordinarias < 0) {
            showAlertWarning('El número de horas extraordinarias debe ser mayor a 0', WErrorSVG, true);
            return;
        }

        if (selecthorasSuplementarias !== undefined && selecthorasSuplementarias < 0) {
            showAlertWarning('El número de horas suplementarias debe ser mayor a 0', WErrorSVG, true);
            return;
        }

        var nroHorasExtrDeOtrasUnidades: number | undefined = 0;
        var nroHorasSuplDeOtrasUnidades: number | undefined = 0;
        var nroHorasExtrDeOtraActividad: number | undefined = 0;
        var nroHorasSuplDeOtraActividad: number | undefined = 0;

        var nroHorasExtrDeEstaActividad: number | undefined = 0;
        var nroHorasSuplDeEstaActividad: number | undefined = 0;

        if (serv.actividadesplanificadas.length > 0) {
            const informacionActividades: Array<{ key: number, value: ActividadesPlanificadas }> = serv.actividadesplanificadas;

            const estructuraActual: number = props.idEstructura
            for (let index = 0; index < informacionActividades.length; index++) {
                const actividad = informacionActividades[index];



                if (actividad.value.idActividad !== props.idActividad) {
                    nroHorasExtrDeOtraActividad += (actividad.value.horasExtraordinarias ?? 0)
                    nroHorasSuplDeOtraActividad += (actividad.value.horasSuplementarias ?? 0)
                }
                else if (actividad.value.idEstructura !== estructuraActual) {
                    nroHorasExtrDeOtrasUnidades += (actividad.value.horasExtraordinarias ?? 0)
                    nroHorasSuplDeOtrasUnidades += (actividad.value.horasSuplementarias ?? 0)
                }
                else {

                    nroHorasExtrDeEstaActividad += (actividad.value.horasExtraordinarias ?? 0)
                    nroHorasSuplDeEstaActividad += (actividad.value.horasSuplementarias ?? 0)
                }

            }

        }

        var maxHorasExtraor = serv.horasextraordinarias + (selecthorasExtraordinarias || 0);
        var maxHorasSuple = serv.horassuplementarias + (selecthorasSuplementarias || 0);
        var sumaHorasExtraSuple = maxHorasExtraor + maxHorasSuple;

        /*
           Cuando se realiza edición de las horas, lo que el usuario ya tiene asignado para esa actividad no se toma en cuenta,
           ya que en teoría es reemplazado por el nuevo valor que se indica.
           Sin embargo si hay que considerar los valores de otras actividades proyectadas, o de la misma actividad pero de  otra unidad

       */
        if (!props.isCrear) {

            maxHorasExtraor = serv.horasextraordinarias - nroHorasExtrDeEstaActividad + (selecthorasExtraordinarias || 0);
            maxHorasSuple = serv.horassuplementarias - nroHorasSuplDeEstaActividad + (selecthorasSuplementarias || 0);
            sumaHorasExtraSuple = maxHorasExtraor + maxHorasSuple
        }


        if (props.factorMesesPlan) {
            if (maxHorasExtraordinarias && maxHorasExtraor > (props.factorMesesPlan * maxHorasExtraordinarias)) {
                showAlertWarning('El servidor que va a seleccionar ya excede el valor límite de horas extraordinarias', WErrorSVG, true);
                return;
            }

            if (maxHorasSuplementarias && maxHorasSuple > (props.factorMesesPlan * maxHorasSuplementarias)) {
                showAlertWarning('El servidor que va a seleccionar ya excede el valor límite de horas suplementarias', WErrorSVG, true);
                return;
            }


            if (maxHorasExtraySuple && sumaHorasExtraSuple > (props.factorMesesPlan * maxHorasExtraySuple)) {
                showAlertWarning('El servidor que va a seleccionar ya excede el valor límite de horas suplementarias y extraordinarias', WErrorSVG, true);
                return;
            }
        }
        else {
            if (maxHorasExtraordinarias && maxHorasExtraor > maxHorasExtraordinarias) {
                showAlertWarning('El servidor que va a seleccionar ya excede el valor límite de horas extraordinarias', WErrorSVG, true);
                return;
            }

            if (maxHorasSuplementarias && maxHorasSuple > maxHorasSuplementarias) {
                showAlertWarning('El servidor que va a seleccionar ya excede el valor límite de horas suplementarias', WErrorSVG, true);
                return;
            }


            if (maxHorasExtraySuple && sumaHorasExtraSuple > maxHorasExtraySuple) {
                showAlertWarning('El servidor que va a seleccionar ya excede el valor límite de horas suplementarias y extraordinarias', WErrorSVG, true);
                return;
            }
        }

        if (serv.numactividades && serv.numactividades === maxNroActividades) {
            showAlertWarning('El servidor que va a seleccionar ya tiene el número máximo de actividades', WErrorSVG, true);
            return;
        }

        const valorHora = calcularValorHorabyRMU(serv.rmu);
        const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(serv.idregimenlaboral, valorHora);
        const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(serv.idregimenlaboral, valorHora);

        const valorTotalSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, horasSuplementarias);
        const valorTotalExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, horasExtraordinarias);
        const valorTotal = calcularValorTotalHora(valorTotalSuplementarias, valorTotalExtraordinarias);

        var valorTechoConsiderarParaPlanificar: number = 0;

        var presupuestoDisponible: number = 0;
        if (regimenValidacion.length > 0) {
            //presupuestoDisponible = regimenValidacion[0].presupuestoDevengar - regimenValidacion[0].planificadoActual;
            presupuestoDisponible = regimenValidacion[0].presupuestoCodificado - regimenValidacion[0].devengadoPagado  - regimenValidacion[0].planificadoActual;
        }
        

        const initialSelection = { ...initialSelectedServidores }

        if (Object.keys(initialSelection).length > 0) {

            let totalActividadesInicial = 0;

            Object.values(initialSelection).forEach((servidor) => {
                const valorHoraInicial = calcularValorHorabyRMU(servidor.rmu);
                const valorHoraSuplementariaInicial = calcularValorHoraSuplementariasbyRMU(servidor.idregimen, valorHoraInicial);
                const valorHoraExtraordinariaInicial = calcularValorHoraExtraordinariabyRMU(servidor.idregimen, valorHoraInicial);

                const valorTotalSuplementariasInicial = calcularValorTotalSuplementarias(valorHoraSuplementariaInicial, servidor.horasSuplementarias);
                const valorTotalExtraordinariasInicial = calcularValorTotalExtraordinarias(valorHoraExtraordinariaInicial, servidor.horasExtraordinarias);
                const valorTotalInicial = calcularValorTotalHora(valorTotalSuplementariasInicial, valorTotalExtraordinariasInicial);

                totalActividadesInicial += valorTotalInicial;
            });

            //Se le devuelve todo al presupuesto, para mas adelante descontar con los nuevos valores
            presupuestoDisponible += totalActividadesInicial;

            


        } 



        console.log(initialSelection);

        if (regimenValidacion.length > 0 && regimenValidacion[0].planificacionMesAnterior && regimenValidacion[0].devengadoNoPagado < regimenValidacion[0].planificacionMesAnterior) {
            valorTechoConsiderarParaPlanificar = regimenValidacion[0].planificacionMesAnterior;
        }
        else if (regimenValidacion.length > 0) {
            valorTechoConsiderarParaPlanificar = regimenValidacion[0].devengadoNoPagado;
        }

        if (unidadesEspeciales.includes(props.idEstructura)) {
            valorTechoConsiderarParaPlanificar = regimenValidacion[0].devengadoNoPagado;
        }

        if ( props.tipo !== "PR" &&   (presupuestoDisponible - valorTechoConsiderarParaPlanificar)  < totalDevengado + valorTotal) {
            showAlertWarning('Se está excediendo del presupuesto a devengar', WErrorSVG, true);
            return;
        }

        setTotalDevengado(prevTotal => prevTotal + valorTotal);




        // Si pasó todas las validaciones, lo seleccionamos
        const newSelection = { ...selectedServidores };
        newSelection[serv.idpersona] = {
            idpersona: serv.idpersona,
            identificacion: serv.identificacion,
            nombrecompleto: serv.nombrescompletos,
            cargo: serv.cargo,
            siglasregimen: serv.siglasregimenlaboral,
            rmu: parseFloat(serv.rmu),
            idregimen: serv.idregimenlaboral,
            horasExtraordinarias: selecthorasExtraordinarias,
            horasSuplementarias: selecthorasSuplementarias,
            observacion:props.observacion
        };

        setSelectedServidores(newSelection);
        //setInitialSelectedServidores(JSON.parse(JSON.stringify(newSelection)))
        props.onSelectionChange(newSelection);
    };


    const handleChangeSelection = (serv:DetalleServidoresProyHEDTO, texto:string) => {
        const newSelection = { ...selectedServidores };
        newSelection[serv.idpersona].observacion = texto;
        setSelectedServidores(newSelection);
        props.onSelectionChange(newSelection);
    }



    const handleInputChange = (e, id, field) => {
        const { value } = e.target;
        const newSelection = { ...selectedServidores };
        if (newSelection[id]) {
            newSelection[id] = {
                ...newSelection[id],
                [field]: value !== '' ? parseFloat(value) : undefined
            };
            setSelectedServidores(newSelection);
            props.onSelectionChange(newSelection);
        }
    };

    return (
        <React.Fragment>
            {regimenSeleccionado !== 0 ? (
                <>
                    <Row>
                        <Col md="9">
                            <div className="d-flex align-items-center justify-content-start">
                                <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                                <select
                                    id="rowsPerPageSelect"
                                    value={rowsPerPage}
                                    onChange={handleRowsPerPageChange}
                                    className="custom-select custom-select-sm mr-2"
                                    style={{ width: 'auto' }}
                                >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                </select>
                                <Label className="mb-0">filas</Label>
                            </div>
                        </Col>
                        <Col md="3">
                            <Input
                                type="text"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={handleSearchChange}
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <div className='table-responsive containerTableAsignarActivServ'>
                        <Table bordered className="table_planificacion_he sticky-table">
                            <thead className="cabeceras_tabla_planificacion_he">
                                <tr className="borde_cabeceras_he">
                                    <th>#</th>
                                    <th className="thIdentificacion" onClick={() => handleSort('identificacion')}>Identificación</th>
                                    <th onClick={() => handleSort('nombrescompletos')} colSpan={2}>Nombres</th>
                                    <th onClick={() => handleSort('cargo')} colSpan={2}>Cargo</th>
                                    <th onClick={() => handleSort('siglasregimenlaboral')}>Régimen</th>
                                    <th className={currentRows && currentRows.length > 0 && isParametroRegimenPlanificacion(currentRows[0]) ? "thHora" : ""} onClick={() => handleSort('horassuplementarias')}>H. <br />Suplem.</th>
                                    <th className={currentRows && currentRows.length > 0 && isParametroRegimenPlanificacion(currentRows[0]) ? "thHora" : ""} onClick={() => handleSort('horasextraordinarias')}>H. <br /> Extraord.</th>
                                    {currentRows && currentRows.length > 0 && isParametroRegimenPlanificacion(currentRows[0]) && <th>Observación</th>}
                                    <th>Seleccionar <input type="checkbox" checked={allSelected} onChange={handleSelectAll} title='Seleccionar todos' /></th>
                                </tr>
                            </thead>
                            <tbody>

                                {currentRows.length > 0 ? (
                                    <>
                                        {
                                            ObtenerTbody(currentRows)
                                        }
                                    </>
                                ) : (
                                    <>

                                    </>

                                )}
                            </tbody>
                        </Table>
                    </div>

                    <Pagination size="sm" className="pagination_planificacion_he">
                        {renderPageNumbers}
                    </Pagination>
                </>

            ) : (
                <>
                    {(regimenSeleccionado !== 0 && currentRows.length <= 0) && (
                        <p>No tiene servidores de el régimen laboral seleccionado</p>
                    )}
                </>

            )}
        </React.Fragment>
    )
}